import { ImportInfo, ImportStatus } from '../../../types/import.types';
export type { ImportInfo, ImportStatus };

export type ImportType = 'bom' | 'stock_and_po';

export interface ImportStorageState {
  isImporting: boolean;
  currentImport: ImportInfo | null;
  historyVersion: number;
}

export const buildImportKey = (type: ImportType): string => `import_${type}`;

export const DEFAULT_IMPORT_STATE: ImportStorageState = {
  isImporting: false,
  currentImport: null,
  historyVersion: 0,
};

export const IMPORT_PROGRESS_TYPES = [
  'import_bom_progress',
  'import_boms',
  'import_stock_and_po_progress',
  'import_stock_and_po',
] as const;

export type ImportProgressType = typeof IMPORT_PROGRESS_TYPES[number];
